import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { AppComponent } from 'app/app.component';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { UserService } from 'shared/services/User/user.service';

@Component({
  selector: 'app-public-groups',
  templateUrl: './public-groups.component.html',
  styleUrls: ['./public-groups.component.css']
})
export class PublicGroupsComponent implements OnInit {
  loading: boolean;
  publicGroups: any = [];
  imageURL: string = environment.URL_TEAM_IMAGES;
  imgProduct = environment.URL_PRODUCT_IMAGES;
  teamId: any;
  user: any;

  constructor(
    private groupService: GroupService,
    private app: AppComponent,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private data: DataSharingService
  ) {
    this.route.params.subscribe((params) => {
      this.teamId = params.teamId;
    });
  }

  ngOnInit() {
    this.loading = true;
    this.app.toggleLoadingMsg('GETTING GROUPS');
    this.user = this.userService.user;
    this.groupService.getPublicGroups(this.teamId).subscribe(res => {
      this.app.dismissLoading();
      this.publicGroups = res.public_groups;
      this.loading = false;
      _.each(this.publicGroups, (publicGroup) => {
        publicGroup.min_split = Math.floor(Number(publicGroup.season_ticket.num_tickets / publicGroup.group_size));
      });
    }, err => {
      this.loading = false;
      this.app.dismissLoading();
    });
  }
  goToViewDetails(groupId) {
    const url = 'new-group/public-groups/view-detail?groupId=' + groupId;
    window.open(url, '_blank');
  }
  goToLoginPage(groupId) {
    this.data.getGroupId(groupId);
    this.router.navigateByUrl('/welcome');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/widget/public-groups/public-groups.component.ts